export class TaskError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TaskError';

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, TaskError.prototype);
  }
}
